const { upgradeArray } = require('../utils')
const { PAYMENTS_METHODS } = require('./_payments')

const RECURRENT_PAYMENTS_TYPES = upgradeArray([ 'threshold', 'frequency' ])
const RECURRENT_PAYMENTS_STATUSES = upgradeArray([ 'init', 'ready', 'error', 'pause', 'block' ])
const RECURRENT_PAYMENTS_METHODS = upgradeArray([ PAYMENTS_METHODS.tinkoff, PAYMENTS_METHODS.mandarin ])

module.exports = {
  RECURRENT_PAYMENTS_TYPES,
  RECURRENT_PAYMENTS_STATUSES,
  RECURRENT_PAYMENTS_METHODS
}
